function canonicalJson(value) {
  if (Array.isArray(value)) return `[${value.map(canonicalJson).join(",")}]`;
  if (value && typeof value === "object") {
    return `{${Object.keys(value)
      .sort()
      .map((key) => `${JSON.stringify(key)}:${canonicalJson(value[key])}`)
      .join(",")}}`;
  }
  return JSON.stringify(value);
}

export function syncRowsStructurallyEqual(left, right) {
  return canonicalJson(left) === canonicalJson(right);
}

/**
 * A full pull may prune rows that were already present when the request began,
 * but only if that exact row stayed unchanged while the request was in flight.
 */
export function authoritativeRowIdsToPrune(
  baselineRows,
  currentRows,
  incomingRows,
  idField,
) {
  const field = String(idField || "").trim();
  if (!field) return [];
  const incomingIds = new Set(
    (Array.isArray(incomingRows) ? incomingRows : [])
      .map((row) => String(row?.[field] || "").trim())
      .filter(Boolean),
  );
  const currentById = new Map(
    (Array.isArray(currentRows) ? currentRows : [])
      .map((row) => [String(row?.[field] || "").trim(), row])
      .filter(([id]) => Boolean(id)),
  );
  const out = [];
  for (const baseline of Array.isArray(baselineRows) ? baselineRows : []) {
    const id = String(baseline?.[field] || "").trim();
    if (!id || incomingIds.has(id)) continue;
    const current = currentById.get(id);
    if (current && syncRowsStructurallyEqual(current, baseline)) out.push(id);
  }
  return out;
}
